import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import { EqColors, EqSizes, EqTypes } from '../../../constants/Eq';
import QATags from '../../../constants/QATags';
import { createBEM } from '../../../lib/utils/css';

import './Eq.scss';

class Eq extends React.Component {
  static propTypes = {
    isPlaying: PropTypes.bool,
    color: PropTypes.oneOf(values(EqColors)),
    size: PropTypes.oneOf(values(EqSizes)),
    qaTag: PropTypes.oneOf(values(QATags)),
  };

  renderEqType = () => {
    if (this.props.color === EqColors.BLACK) {
      return this.props.isPlaying ? EqTypes.PLAYING_BLACK : EqTypes.PAUSED_BLACK;
    } else if (this.props.color === EqColors.BLUE) {
      return this.props.isPlaying ? EqTypes.PLAYING_BLUE : EqTypes.PAUSED_BLUE;
    }
    return this.props.isPlaying ? EqTypes.PLAYING_WHITE : EqTypes.PAUSED_WHITE;
  };

  render() {
    const { size, qaTag } = this.props;
    const classes = createBEM('Eq', {
      [size]: !!size,
    });
    // eslint-disable-next-line jsx-a11y/alt-text
    return <img className={classes} src={this.renderEqType()} data-qa={qaTag} />;
  }
}

export default Eq;
